import androidx.compose.runtime.Composable
import net.sergeych.ugdx. shared.Currency
import net.sergeych.ugdx.shared.api.ApiAccount
import org.jetbrains.compose.web.attributes.name
import org.jetbrains.compose.web.attributes.selected
import org.jetbrains.compose.web.dom.*

class AccountSelectAttrsBuilder {
    var onChange: (value: ApiAccount?) -> Unit = {}
    var label: @Composable() () -> Unit = {}
    var options: List<ApiAccount> = emptyList()
    var isDisabled = false

    fun onChange(handler: (value: ApiAccount?) -> Unit) { onChange = handler }
    fun label(l: @Composable() () -> Unit) { label = l }
    fun disabled() { isDisabled = true }
    fun options(list: List<ApiAccount>) { options = list }
}

@Composable
fun AccountSelect(
    id: String,
    selected: ApiAccount?,
    attrs: AccountSelectAttrsBuilder.() -> Unit = {}
) {
    val builder = AccountSelectAttrsBuilder()
    attrs.invoke(builder)

    Div() {
        Label(forId = id, attrs = {
            classes("block", "text-sm", "font-medium", "text-gray-700")
        }) { builder.label() }

        Select(attrs = {
            id(id)
            name("select")
            classes("mt-1", "block", "w-full", "pl-3", "pr-10", "py-2", "text-base", "border-gray-300", "focus:outline-none", "focus:ring-indigo-500", "focus:border-indigo-500", "sm:text-sm", "rounded-md")
            onChange {
                val code = it.value
                val acc = builder.options.find { it.id.toString() == code }
                builder.onChange(acc)
            }
        }) {
            builder.options.forEach {
                val option = it

                Option(option.id.toString(), attrs = {
                    if (selected?.id == option.id) selected()
                }) { Text(option.name ?: option.id.toString()) }
            }
        }
    }
}